import { State } from '../../../../types';
import { Asset, AssociatedDevice, SortDirection } from '../../components/assets/types';
import { SelectedTag } from '../../components/assets/details/types';
import { AssetsListDetailTab } from '../../containers/assets/details/types';

export function getAssets(state: State): Asset[] {
    return state.assets.assets;
}

export function getAssetsTableViewType(state: State): string {
    return state.assets.tableViewType;
}

export function getSelectedAsset(state: State): Asset | null {
    return state.assets.selectedAsset;
}

export function getAssetTableSortColumn(state: State): string | null {
    return state.assets.sortBy;
}

export function getAssetTableSortDir(state: State): SortDirection {
    return state.assets.sortDir;
}

export function getFetching(state: State): boolean {
    return state.assets.fetching;
}

export function getFetchingSelectedDevice(state: State): boolean {
    return state.assets.selectedDevicesFetching;
}

export function getSelectedAssociatedDevices(state: State): AssociatedDevice[] {
    return state.assets.selectedAssociatedDevices;
}

export function getAssociatedDevices(state: State): { [key: string]: AssociatedDevice[] } {
    return state.assets.associatedDevices;
}

export function getAssetUpdating(state: State): boolean {
    return state.assets.assetUpdating;
}

export function getAssetDeleting(state: State): boolean {
    return state.assets.assetDeleting;
}

export function getAssetUpdateSuccessful(state: State): boolean {
    return state.assets.assetUpdateSuccessful;
}

export function getAssetUpdateFailed(state: State): boolean {
    return state.assets.assetUpdateFailed;
}

export function getAssetUpdateErrorCode(state: State): string | null {
    return state.assets.assetUpdateErrorCode;
}

export function getDisplayDeleteDialog(state: State): boolean {
    return state.assets.displayDeleteDialog;
}

export function getDeletionSuccessful(state: State): boolean {
    return state.assets.deletionSuccessful;
}

export function getDeletionErrorMessageCode(state: State): string | null {
    return state.assets.deletionErrorMessageCode;
}

export function getAssetTagsUpdating(state: State): boolean {
    return state.assets.tags.updating;
}

export function getAssetTagLastSuccessfullyRemoved(state: State): SelectedTag | null {
    return state.assets.tags.removals.lastSuccess;
}

export function getAssetTagsLastFailedAdded(state: State): SelectedTag | null {
    return state.assets.tags.additions.lastFailure;
}

export function getAssetTagsLastFailedRemoved(state: State): SelectedTag | null {
    return state.assets.tags.removals.lastFailure;
}

export function getAssetTagLastSuccessfullyAdded(state: State): SelectedTag | null {
    return state.assets.tags.additions.lastSuccess;
}

export function getAssetDetailTab(state: State): AssetsListDetailTab {
    return state.assets.currentAssetDetailsTab;
}

export function getSearchString(state: State): string {
    return state.assets.searchString;
}

export function getShowOnlyAssetsWithoutDataSource(state: State): boolean {
    return state.assets.filters.showOnlyAssetsWithoutDataSource;
}

export function getShowActiveAssets(state: State): boolean {
    return state.assets.filters.showActiveAssets;
}

export function getShowArchivedAssets(state: State): boolean {
    return state.assets.filters.showArchivedAssets;
}

export function getShowFilterOptionsDialog(state: State): boolean {
    return state.assets.showFilterOptionsDialog;
}
export function getEasyOnboardingSelectedAssetId(state: State): string | undefined {
    return state.assets.easyOnboardingDialog.selectedAssetId;
}

export function getIsAssetsReloadImminent(state: State): boolean {
    return state.assets.isAssetsReloadImminent;
}
